/* eslint-disable max-len */
/* eslint-disable max-statements */
import {useEffect} from 'react';
import {getExonerationPerc} from '../../../../../budgetVehicles/utils';
import {passportDigits} from '../../../../constants/commons';
import {completeWithCeros} from '../../../../utils/commonUtils';
const useClient = ({
  clientTypes,
  data,
  dataError,
  exonerationsList,
  handleChange,
  formValidations,
  fetchFloatClientInfo,
  fetchFlInventoryAttachments,
  setCurrentFloatingLine,
  dealerId,
  isUserTde,
  currentLineOriginal,
}) => {
  const isSolNac = data.floatingState === 'S';
  
  useEffect(() => {
    data?.id && fetchFlInventoryAttachments(`${data.document}/${data.dealerReservation}`);
  }, []);

  useEffect(() => {
    const exonerationPercentaje = getExonerationPerc(data.clientType, data.discapacityPerc, exonerationsList);
    handleChange('exonerationPerc', exonerationPercentaje, formValidations.exonerationPerc(data));
  }, [data.clientType, data.discapacityPerc]);

  useEffect(() => {
    if (data.documentType === 'P') {
      data.document && handleChange('document', completeWithCeros(data.document, passportDigits));
    }
  }, [data.documentType]);

  useEffect(() => {
    if (data.legalRepresentativeType === 'P') {
      data.legalRepresentativeId && handleChange('legalRepresentativeId', completeWithCeros(data.legalRepresentativeId, passportDigits));
    }
  }, [data.legalRepresentativeType]);

  
  const handleDocumentChange = (name, value, validation) => {
    let valueToUpdate = value;
    if (data.documentType === 'P') {
      valueToUpdate = completeWithCeros(value, passportDigits);
    }
    handleChange(name, valueToUpdate);
    setCurrentFloatingLine({'data': {
      ...data,
      'document': valueToUpdate,
      'floatingState': currentLineOriginal?.floatingState,
    },
    isUserTde, dealerId});
    
    if (valueToUpdate === currentLineOriginal.document || !value) {
      return;
    }
    fetchFloatClientInfo(valueToUpdate, data.dealerReservation);
    fetchFlInventoryAttachments(`${valueToUpdate}/${data.dealerReservation}`);
  };

  const handleDocumentRepChange = (name, value, validation) => {
    let valueToUpdate = value;
    if (data.legalRepresentativeType === 'P') {
      valueToUpdate = completeWithCeros(value, passportDigits);
    }
    handleChange(name, valueToUpdate, validation);
  };

  const handleDocumentTypeChange = (name, value, validation = []) => {
    handleChange(name, value, validation);
    if (value === 'C') {
      handleChange('clientType', '001', formValidations.clientType(data));
      handleChange('contributorCode', 'P', formValidations.contributorCode(data));
    }
    if (value === 'R') {
      handleChange('clientType', '002', formValidations.clientType(data));
    }
    if (value === 'P') {
      handleChange('contributorCode', '3', formValidations.contributorCode(data));
    }
  };

  const handleClientTypeChange = (name, value, validation) => {
    let valuedocumentType = null;
    if (value === '001') {
      valuedocumentType = 'C';
    } else if (value === '002') {
      valuedocumentType = 'R';
      handleChange('contributorCode', '', formValidations.contributorCode(data));
    } else {
      valuedocumentType = 'R';
    }
    handleDocumentTypeChange('documentType', valuedocumentType, formValidations.documentType(data));
    handleChange(name, value, validation);
  };

  const generateClientTypesList = (ids) => clientTypes.filter((clientType) => ids.includes(clientType.code));

  const mappedClientTypes = data.businessType === 'D' ? generateClientTypesList(['001']) : (
    ['O', 'C'].includes(data.businessType) ? generateClientTypesList(['002']) :
      (data.businessType === 'P' ? generateClientTypesList(['005']) : [])
  );
  const clientFilesKey = `${data.document}/${data.dealerReservation}`;

  return {
    'actions': {
      handleDocumentChange,
      handleClientTypeChange,
      handleDocumentRepChange,
    },
    'dataValues': {
      data,
      dataError,
      isSolNac,
      mappedClientTypes,
      clientFilesKey,
    },
  };
};
export default useClient;
